/* eslint-disable camelcase */
import { SocialNetworksErrorCode } from '../emun/social'
import { DeployTypes } from '../emun/DeployTypes'

export enum Languages {
  RU = 'ru',
  KZ = 'kz',
  UZ = 'uz',
}

export enum HtmlLanguages {
  RU = 'ru',
  KZ = 'kk',
  UZ = 'uz',
}

export interface IBackendServers {
  [Languages.RU]: string
  [Languages.KZ]: string
  [Languages.UZ]: string
}

export interface IStoreItemState {
  isFetching: boolean
  hasError: boolean
}

export interface IUser {
  id: string
  middleName?: string
  gender?: string
  phone?: string
  email?: string
  birthday?: string
  lastName?: string
  firstName?: string
  isAuthenticated: boolean
}

export interface ILogonQueryParams {
  [key: string]: any
  appid?: number
  appId?: number
  form?: string
  reglink?: string
  returnurl?: string
  callbackurl?: string
  redirectUrl?: string
  p?: number
  login?: string
  lang?: string
  userEmail?: string
  hide_social_buttons?: string
  finish?: string
  mode?: string
}

export type TQueryParams = ILogonQueryParams

interface IRegistrationQueryParams extends TQueryParams {
  form?: string
  utm_campaign?: string
  utm_content?: string
  utm_medium?: string
  utm_source?: string
  utm_term?: string
  widget?: string
}

export type TRegistrationQueryParams = IRegistrationQueryParams

interface IRegistrationSuccessQueryParams extends TQueryParams {
  code?: string
  email?: string
  emailHost?: string
  resendEmail?: boolean
}

export type TRegistrationSuccessQueryParams = IRegistrationSuccessQueryParams

export interface IAuthFromSocialParams extends TQueryParams {
  code?: SocialNetworksErrorCode
}

interface IHostsConfig {
  [Languages.RU]: string
  [Languages.KZ]: string
  [Languages.UZ]: string
}

export interface IEnvironmentHostsConfig {
  [DeployTypes.Development]: IHostsConfig
  [DeployTypes.ReleaseCandidate]: IHostsConfig
  [DeployTypes.Production]: IHostsConfig
}

export interface IError {
  response: {
    status?: number
  }
}

export interface IResponse<Data> {
  message: string
  data: Data
}
